import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import TableLoader from './Loader/TableLoader'; 

interface Item {
  id: number;
  folder_name: string;
  category: string;
  album_name: string;
  album_code: string;
  post_date: string;
  slug: string;
  uploaded_by: string;
  album_image: string;
  // Add more properties as per your item structure
}

interface currentLatestTableProps {
  items: Item[];
  loading: boolean;
  onView: (id: number) => void;
  onEdit: (id: number, album_code: string) => void;
  onDelete: (id: number) => void;
}

export default function CurrentLatestTable({ items, loading, onView, onEdit, onDelete }: currentLatestTableProps) {
  const [latestPage, setLatestPage] = useState(1);
  const latestPerPage = 10;
  const totalPages = Math.ceil(items.length / latestPerPage)
  const indexOfLastLatest = latestPage * latestPerPage;
  const indexOfFirstLatest = indexOfLastLatest - latestPerPage;
  const currentLatest = items.slice(indexOfFirstLatest, indexOfLastLatest);

  const nextLatestPage = () => {
    if (latestPage < totalPages) { 
      setLatestPage(latestPage + 1)
    }
  };

  const prevLatestPage = () => {
    if (latestPage > 1) {
      setLatestPage (latestPage - 1)
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [latestPage]);

  return (
    <>
      {loading ?
        (
          <TableLoader />
        )

        :

        (
          <table>
            <thead className="bg-gray-200">
              <tr>
                <th style={{ width: '10%' }} >Post Date</th>
                <th style={{ width: '20%' }} >Category</th>
                <th style={{ width: '20%' }} >Album Name</th>
                <th style={{ width: '20%' }} >Album Code</th>
                <th style={{ width: '20%' }} >Uploaded By</th>
                <th style={{ width: '10%' }} className='text-center'>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentLatest.length !== 0 ?
                (
                  currentLatest.map(item => ((
                    <tr key={item.id}>
                      <td>{item.post_date}</td>
                      <td>{item.category}</td>
                      <td>{item.album_name}</td>
                      <td>{item.album_code}</td>
                      <td>{item.uploaded_by}</td>
                      <td className='text-center'>
                        <button 
                          onClick={() => onEdit(item.id, item.album_code)} 
                          data-tooltip-id='edit'>
                          <FontAwesomeIcon icon={faPenToSquare} className="text-sx text-white bg-red-600 rounded-md p-1 mr-2" />
                        </button>

                        <button 
                          onClick={() => onDelete(item.id)} 
                          type='button' 
                          data-tooltip-id='delete'>
                          <FontAwesomeIcon icon={faTrash} className="text-sm text-white bg-gray-600 rounded-md p-1" />
                        </button>
                      </td>
                    </tr>
                  )))
                )

                :

                (
                  <tr>
                    <td colSpan={6} className="text-center">No data available!</td>
                  </tr>
                )
              }
            </tbody>
          </table>
        )
      }

      {totalPages > 1 && (
        <div className="flex justify-center items-center mt-4 space-x-4">
          <button
            onClick={() => setLatestPage(1)}
            className="px-3 py-1 rounded disabled:opacity-50 text-white bg-gray-500"
            disabled={latestPage === 1}>
            First
          </button>

          <button
            onClick={prevLatestPage}
            className="px-3 py-1 rounded disabled:opacity-50 text-white bg-gray-500"
            disabled={latestPage === 1}>
            Prev
          </button>

          {/* Numbered page buttons */}
          {[...Array(totalPages)].map((_, index) => {
            const pageNum = index + 1;
            const range = 1; // Show one before and after
            const show = pageNum >= latestPage - range && pageNum <= latestPage + range;

            if (show) {
              return (
                <button
                  key={pageNum}
                  onClick={() => setLatestPage(pageNum)}
                  className={`px-3 py-1 rounded ${
                    latestPage === pageNum
                      ? "bg-red-600 text-white"
                      : "bg-gray-200 text-black"
                  }`}
                >
                  {pageNum}
                </button>
              );
            }
            return null;
          })}

          <button
            onClick={nextLatestPage}
            className="px-3 py-1 rounded disabled:opacity-50 text-white bg-red-500"
            disabled={latestPage === totalPages}>
            Next
          </button>

          <button
            onClick={() => setLatestPage(totalPages)}
            className="px-3 py-1 rounded disabled:opacity-50 text-white bg-red-500"
            disabled={latestPage === totalPages}>
            Last
          </button>
        </div>
      )}
    </>
  )
}